<template>
    <div>
        <h4 class="title-section">{{ t('Cheapest offers') }}</h4>
        <div class="row offers-section" v-for="offer in offers">
            <div class="col-lg-2 col-md-2">
                <div v-if="offer['shopClassName']" class="shop-logo" :class="offer['shopClassName']"></div>
                <span v-else>{{ offer['shopName'] }}</span>
            </div>
            <div class="col-lg-9 col-md-8">
                <a :href="offer['productLink']" target="_blank" >{{ offer['productName'] }}</a>
            </div>
            <div class="col-lg-1 col-md-2">
                <h5 class="">{{ offer['price'] }}</h5>
            </div>
        </div>
    </div>
</template>

<script>
    export default
    {
        props: {
            offers: {
                Type: Array,
                Default: []
            }
        },
        components: {},
        data() {
            return {
            };
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style lang="sass">
    .shop-logo {
        height: 32px;
    }
    .title-section {
        margin-top: 2px;
    }
    .offers-section {
        margin-right: 5px;
        line-height: 32px;
    }
</style>


// WEBPACK FOOTER //
// offers.vue?ee8d552c